import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import { CONTENT } from '../content';

export default function CuriousStrip() {
  const { language } = useLanguage();
  const t = CONTENT[language].curiousStrip;

  return (
    <div className="bg-suncoast-dark border-b border-gray-800">
      <div className="container mx-auto px-4 lg:px-12 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-white mb-2">{t.title}</h3>
            <p className="text-xs text-gray-400 max-w-md">{t.legal}</p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4">
            <a href={`mailto:${t.emailBtn}`} className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 text-white rounded transition-colors text-sm">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
              {t.emailBtn}
            </a>
            <a href={`tel:${t.callBtn.replace(/\D/g,'')}`} className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 text-white rounded transition-colors text-sm">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
              {t.callBtn}
            </a>
            <Link to="/contact" className="px-6 py-2 bg-suncoast-accent hover:bg-orange-600 text-white font-bold rounded shadow-lg transition-transform transform hover:-translate-y-0.5 text-sm">
              {t.bookBtn}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
